import React, { useState, useCallback, useEffect } from "react";
import DataTable from "react-data-table-component";
import { Colors } from "../../../../utils/colors/colors";
import styled from "styled-components";
import { toast } from "react-toastify";
import { useExport } from "../../../../hooks/useExport";
import MarkAttendance from "./MarkAttendance";
import InputComponent from "../../../../utils/input/Input";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Schema } from "../../../../validators/schema/schema";
import ButtonComponent from "../../../../utils/button/ButtonComponent";
import { Col, Row } from "react-bootstrap";









const ResponsiveTable = ({ data }) => {
  const [tableData, setTableData] = useState(data);
  const [searchQuery, setSearchQuery] = useState('');






  const {
    handleSubmit,
    formState: { errors },
    control,
    register,
  } = useForm({
    resolver: yupResolver(Schema().RSVPSearchQueryFormSchema),
    mode: "onBlur",
  });



  // Filter logic extracted to a function
  const filterRSVPData = useCallback((RSVPData, query) => {
    if (!query) {
      return RSVPData;
    }

    const normalizedQuery = query.trim().toLowerCase();

    return RSVPData.filter((attendee) => {
      const { name, email, ageRange, gender } = attendee;

      const matchesQuery = [name, email, ageRange, gender]
        .join(' ')
        .toLowerCase()
        .includes(normalizedQuery);

      return matchesQuery;
    });
  }, []);

  useEffect(() => {
    const filteredData = filterRSVPData(data, searchQuery);
    setTableData(filteredData);
  }, [data, searchQuery, filterRSVPData]);

  const filteredRSVPData = filterRSVPData(tableData || [], searchQuery);






  /**
   * A responsive table component for displaying data from the OpenForum RSVP
   * API. This component is responsible for rendering the table of data and
   * providing a user interface for deleting attendees.
   *
   * The component accepts a single prop, `data`, which is an array of objects
   * representing the data from the OpenForum RSVP API.
   *
   * The component renders a table with the following columns:
   *
   * - Attendance: A column containing the attendance status of the attendee.
   * - Full Name: A column containing the full name of the attendee.
   * - Email: A column containing the email address of the attendee.
   * - Gender: A column containing the gender of the attendee.
   * - Qualification: A column containing the qualification of the attendee.
   * - Work Device: A column containing the work device of the attendee.
   * - Emp. Status: A column containing the employment status of the attendee.
   * - Resume: A column containing the resume of the attendee.
   * - Location: A column containing the location of the attendee.
   * - Age: A column containing the age of the attendee.
   *   of the attendee.
   * - Delete: A column containing a delete button for deleting the attendee.
   *
   * The component also renders a search bar at the top of the table for
   * filtering the data by the attendee's name.
   *
   * @param {object} data An array of objects representing the data from the
   * OpenForum RSVP API.
   * @returns A responsive table component for displaying the data.
   */




  const { dangerColor } = Colors();
  const {
    deleteIcon,
  } = useExport();
  const { primaryColor } = Colors();


  const onSubmit = useCallback(async (data) => {
    setSearchQuery(data?.query);
  }, []);



  const columns = [
    {
      name: "Attendance",
      cell: (row) => (
        <>
          <MarkAttendance
            data={row}
          />
        </>
      ),
    },
    {
      name: "Full Name",
      selector: (row) => row.name,
      sortable: true,
      wrap: true,
    },
    {
      name: "Email",
      selector: (row) => {
        return (<><a href={`mailto:${row.email}`}>{row.email}</a></>)
      },
      sortable: true,
      wrap: true,
    },
    {
      name: "Gender",
      selector: (row) => row.gender,
      sortable: true,
    },
    {
      name: "Qualification",
      selector: (row) => row.educationalQualification,
      sortable: true,
      wrap: true,
    },
    {
      name: "Work Device",
      selector: (row) => row.currentDeviceUsed,
      cell: (row) => {
        const deviceArray =
          typeof row.currentDeviceUsed === "string"
            ? JSON.parse(row.currentDeviceUsed.replace(/'/g, '"'))
            : row.currentDeviceUsed;

        const hasLaptop = deviceArray.includes("Laptop");

        return (
          <span
            style={{
              color: hasLaptop ? "inherit" : dangerColor,
            }}
          >
            {deviceArray.join(", ")}
          </span>
        );
      },
      sortable: true,
    },
    {
      name: "Emp. Status",
      selector: (row) => row.employmentStatus,
      sortable: true,
      wrap: true,
    },
    {
      name: "Resume",
      sortable: true,
      selector: (row) => row.cv,
      cell: (row) =>
        row.cv ? (
          <a href={row.cv} target="_blank" rel="noopener noreferrer">
            Download CV
          </a>
        ) : (
          "No CV submitted"
        ),
    },
    {
      name: "Location",
      selector: (row) => row.country,
      cell: (row) => {
        if (!row.country) return "Ibadan";
        return row.country.toLowerCase().includes("ibadan")
          ? "Ibadan"
          : "Ghana";
      },
      sortable: true,
    },
    {
      name: "Age",
      selector: (row) => row.ageRange,
      sortable: true,
    },
    {
      name: "Digital Tools Experience",
      selector: (row) => row.experienceDigitalTools,
      sortable: true,
    },
    {
      name: "Delete",
      cell: (row) => (
        <div style={{ display: "flex", gap: "12px", cursor: "pointer" }}>
          <img
            src={deleteIcon}
            alt="delete-attendee"
            onClick={() => {
              toast.info("Coming soon...");
              console.log(row.id);
            }}
          />
        </div>
      ),
    },
  ];

  return (
    <>

      <form onSubmit={handleSubmit(onSubmit)}>

        <Row>
          <Col
            xs={{ span: 12, order: 1 }}
            md={{ span: 6, order: 1 }}
            lg={{ span: 8, order: 1 }}
          >
            <InputComponent
              label={"Query"}
              placeholder={"Enter your query"}
              hasLabel={true}
              name={"query"}
              errorText={errors?.name?.message}
              rest={{ ...register("query") }}
              id={"query"}
              type={"search"}
              cName={"form-input"}
              style={{
                width: "100%",
              }}
              control={control}
              defaultValue={""}
            />
          </Col>


          <Col
            xs={{ span: 12, order: 2 }}
            md={{ span: 6, order: 2 }}
            lg={{ span: 4, order: 2 }}
          >
            <BtnWrapper>
              <ButtonComponent
                bgColor={primaryColor}
                text={"Search"}
                style={{
                  minWidth: "100%",
                  margin: "2.125rem auto 1rem auto",
                }}
                click={handleSubmit(onSubmit)}
                isLoading={false}
              />
            </BtnWrapper>
          </Col>
        </Row>
      </form>


      <TableWrapper>
        <DataTable
          columns={columns}
          data={filteredRSVPData}
          pagination
          highlightOnHover
          striped
          customStyles={customStyles}
          title="2025 OpenForum RSVP Data"
        />
      </TableWrapper>
    </>
  );
};

export default ResponsiveTable;


const TableWrapper = styled.div`
  margin-top: 40px;
  overflow-x: auto;
`;

const customStyles = {
  headRow: {
    style: {
      backgroundColor: "#4f4f4f",
      color: "#ffffff",
      fontWeight: "bold",
      fontSize: "1rem"
    },
  },
};


const BtnWrapper = styled.div`
`;
